import { tableStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryTable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

tableStyles.container = {
    ...tableStyles.container,

    css: css`
        ${tableStyles.container?.css}

        position: relative;
        margin-top: 10px;
    `,
};

tableStyles.shipToCell = {
    ...tableStyles.shipToCell,
    css: css`
        ${TypographyStyle} {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: block;
            max-width: 300px;
        }
    `,
};
